import React from "react";
import "./style.css";
import Header from "./Header";
import Roadmap from "./Roadmap";
import DirectPurchasePage from "./DirectPurchase";
import BuyFullNodePage from "./BuyFullNode";
import CoinTable from "./CoinTable";
import ScrollTop from "./ScrollTop";
// import FAQ from "./Faq";
import About from "./About";
import Footer from "./Footer";
import Features from "./Feature";
import { GoogleOAuthProvider } from "@react-oauth/google";

const Website = () => {
  const GoogleClientId= process.env.REACT_APP_GOOGLE_CLIENT_ID;
  return (
    <>
      {/* {--------    Header section ---------  } */}
      <GoogleOAuthProvider clientId={`${GoogleClientId}`} >
        <Header />
      </GoogleOAuthProvider>

      {/*  -------------   Features section  -------------------- */}
      <Features />

      {/* -----------------   Roadmap section   ------------------   */}
      <Roadmap />

      {/* -----------------   Direct Purchase Page  ------------------   */}
      <DirectPurchasePage />

      {/* -----------------   Buy Full Node Page ------------------   */}
      {/* <BuyFullNodePage/> */}

      {/* -----------------   Coin table section   ------------------   */}
      <CoinTable />
      {/* ----------------   FAQs section  ----------------*/}
      <ScrollTop />
      {/* <FAQ/> */}
      <About />
      <Footer />
    </>
  );
};

export default Website;
